export default __webpack_public_path__ + "static/media/task2.f5403c14.svg";